/**
 * TipoPessoaRecebedor
 * @author Simpli CLI generator
 */
import {
    $,
    HttpBody,
    ID,
    Resource,
    ResponseSerialize,
    TAG,
    ValidationMaxLength,
    ValidationRequired,
} from 'simpli-web-sdk'
import TipoPessoaRecebedorSchema from '@/schema/TipoPessoaRecebedor.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class TipoPessoaRecebedor extends Resource {

    get $schema() {
        return TipoPessoaRecebedorSchema(this)
    }

    get $id() {
        return this.idTipoPessoaPk
    }

    set $id(val: ID) {
        this.idTipoPessoaPk = val
    }

    get $tag() {
        return this.nome
    }

    set $tag(val: TAG) {
        this.nome = val
    }

    static async persistLoteTipoOcorrencia(listToPersist: TipoPessoaRecebedor[],
                                           spinner = 'persistLoteTipoPessoaRecebedor') {
        const fetch = async () => {
            return await new HttpBody(Number).POST(`/user/lote-tipo-recebedor-pessoa`, listToPersist)
        }

        return await $.await.run(fetch, spinner)
    }

    get idReponsavelFk() {
        return this.responsavel!.idResponsavelPk
    }

    set idResponsavelFk(value: ID) {
        this.responsavel!.idResponsavelPk = value
    }

    readonly $name: string = 'TipoPessoaRecebedor'

    readonly $endpoint: string = '/user/tipo-recebedor-pessoa{/id}'

    @ResponseSerialize(Responsavel)
    responsavel: Responsavel | null = null

    idTipoPessoaPk: ID = 0

    @ValidationRequired()
    @ValidationMaxLength(100)
    nome: string = ''

    @ValidationRequired()
    ativo: boolean = false

    async getTipoPessoaRecebedor(id: ID, spinner = 'getTipoPessoaRecebedor') {
        const fetch = async () => await this.GET(`/user/tipo-recebedor-pessoa/${id}`)
        return await $.await.run(fetch, spinner)
    }

    async removeTipoPessoaRecebedor(id: number, spinner = 'removeTipoPessoaRecebedor') {
        const fetch = async () => await this.DELETE(`/user/tipo-recebedor-pessoa/${id}`)
        return await $.await.run(fetch, spinner)
    }
}
